export default __webpack_public_path__ + "static/media/wax.6f0ca329.png";